import { CompanyExcel } from "../../domain/entities/CompanyExcel"
import { CompanyExcelRepository } from "../../domain/repositories/CompanyExcelRepository"
import { CompanyExcelService } from "../services/CompanyExcelService"
import { UploadCompanyExcelDTO } from "../dto/UploadCompanyExcel.dto"

interface Props {
	CompanyExcelService: CompanyExcelService
}

export class CompanyExcelRepositoryImpl implements CompanyExcelRepository {
	private _companyExcelService: CompanyExcelService

	constructor({ CompanyExcelService }: Props) {
		this._companyExcelService = CompanyExcelService
	}

	async getCompanyExcels(): Promise<CompanyExcel[]> {
		return await this._companyExcelService.getCompanyExcels()
	}

	async uploadCompanyExcel(data: UploadCompanyExcelDTO): Promise<{ success: boolean; message: string }> {
		return await this._companyExcelService.uploadCompanyExcel(data)
	}

	async sendEmail(companyExcelId: number): Promise<{ success: boolean; message: string }> {
		return await this._companyExcelService.sendEmail(companyExcelId)
	}
}
